<div class="modal-header">
  <h4 class="modal-title">
    Tags
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">

  <div class="container-fluid">
    <div class="row">

      <div class="col-12 rounded bg-light py-3 text-end mb-4">
        <button
          type="button"
          (click)="open()"
          class="btn btn-success rounded-circle me-2">
          <i class="material-icons mt-1">add</i>
        </button>
  
        <button
          type="button"
          (click)="getAll()"
          class="btn btn-primary rounded-circle me-2">
          <i class="material-icons mt-1">refresh</i>
        </button>
      </div>

      @if(loading) {

        <div class="d-flex justify-content-center">
          <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

      } @else {

        @for(tag of tags; track $index) {

          <div class="col-12 rounded bg-light py-3 text-end mb-4">
            <div class="row">

              <div class="col text-start">
                @if(tag.tagType) {
                  @if(tag.tagType.image) {
                    <img
                      [src]="tag.tagType.image.urlFile"
                      [alt]="tag.tagType.image.urlFile"
                      style="width: 5vh; height: 5vh;">
                  }
                }
              </div>

              <div class="col d-flex align-items-center text-center">
                {{ tag.id }}
              </div>

              <div class="col d-flex align-items-center text-center">
                {{ tag.status ? 'Activo' : 'Inactivo' }}
              </div>

              <div class="col-auto">
                <button
                  type="button"
                  (click)="open(tag)"
                  class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">edit</i>
                </button>

                <button
                  type="button"
                  (click)="delete(tag)"
                  class="btn btn-danger rounded-circle me-2">
                  <i class="material-icons mt-1">delete</i>
                </button>
              </div>

            </div>
          </div>
        }

      }


    </div>
  </div>
  
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-success w-100">
      OK
    </button>
  </div>
</div>
